module.exports = __webpack_public_path__ + "img/mono_4.510d55ce.png";